import MoneyFunctions from '../../domain/Money';
import { Variant } from '../../api/types/ClientProduct';

export default function showOriginalPrice(variant?: Variant): boolean {
    return variant?.originalPrice && Boolean(variant?.price)
        ? MoneyFunctions.greaterThan(variant?.originalPrice, variant?.price)
        : false;
}
